/* eslint-disable no-restricted-syntax */
import Linkify from 'linkify-it';

const linkify = new Linkify();

/**
 * Allowed domains
 *
 * Generally just include first 2 letters of suffix as it would otherwise fail there. (e.g. `.co`)
 */
const allowedDomains = ['skyhookadventure.co', 'drive.google', 'dropbox'];

/**
 * React-hook-form prevent links validator
 */
export function preventURLsValidator(value: string): boolean {
  const matches = linkify.match(value) || [];

  // Return false if there are any links that don't go to skyhookadventure.com
  for (const match of matches) {
    const url = match?.url;

    const isAllowed = allowedDomains.some((domain) => url?.includes(domain));
    if (!isAllowed) return false;
  }

  return true;
}
